import { call, select, takeLatest } from "redux-saga/effects";
import actionTypes from "../../actions/actionTypes";
import { getCliDataCall } from "../../apis/wpApi/apiCalls";
import authUser from "../../apis/wpApi/authUser";
import { putError, putSuccess } from "../helpers";


function* getData({payload}) {
    try {
        const apiKey = yield call(authUser.getToken)
        const response = yield call(getCliDataCall, apiKey, payload.signal)

        yield putSuccess(actionTypes.CLI_DATA_GET_SUCCESS, response.data)
    } catch(e) {
        yield putError(actionTypes.CLI_DATA_GET_ERROR, e.message)
    }
}


function* cliDataSaga() {
    yield takeLatest(actionTypes.CLI_DATA_GET_REQUEST, getData)
}

export default cliDataSaga;